// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__8UhT-","block":"styles_block__8pP2H"};